import {NavLinkProps} from 'epic-games-nav/dist/client';
import epicTracking from 'epic-tracking';
import history from 'history';
import root from 'window-or-global';

import {lastRoutePart, isExternalAppPath, generateMainSitePath} from '../../utils/FortniteUtils';

/**
 * Returns true if viewer is currently navigating the esports site /competitive/locale:/
 */
export const isOnEsports = (pathname: string): boolean => {
  if (pathname.indexOf('competitive') > -1) {
    return true;
  }
  return false;
};

export const isEsports = (link: NavLinkProps, pathname: string): boolean => {
  if (link && link.href && link.href.indexOf('competitive') > -1) {
    if (pathname.indexOf('competitive') > -1) {
      return true;
    }
  }
  return false;
};

export const shouldUseClientSideRoute = (link: NavLinkProps, pathname: string): boolean => {
  const isEsportsValue = isEsports(link, pathname);
  if (isEsportsValue) return true;

  if (pathname && isExternalAppPath(pathname)) {
    return false;
  }
  return true;
};

export const trackNavigationClick = (label: string): void => {
  try {
    const cleanedLabel = lastRoutePart(label);
    epicTracking.trackEvent('Interaction', {
      eventCategory: 'fn-web',
      eventAction: 'fn-nav',
      eventLabel: cleanedLabel,
      eventValue: 1,
      interactionType: 'click',
    });
  } catch (error) {
    console.error(`Nav click tracking failed. Parameters - label: ${label}`, error);
  }
};

export function routeMainSitePath(
  history: history.History,
  location: history.Location,
  pathname: string
) {
  const path = generateMainSitePath(pathname);

  if (path) {
    if (isExternalAppPath(location.pathname)) {
      root.location.href = path;
    } else {
      history.push(path);
    }
  }
}
